import { render } from "./NatStep3.vue?vue&type=template&id=5e1a5ad6&scoped=true"
import script from "./NatStep3.vue?vue&type=script&lang=js"
export * from "./NatStep3.vue?vue&type=script&lang=js"

import "../form.css?vue&type=style&index=0&id=5e1a5ad6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1a5ad6"]])

export default __exports__